import React, { useEffect } from "react";
import "./Banking.css";
import Button from "../../components/Button/Button";
import { Container, Row, Col, Card } from "react-bootstrap";
import legacyimage from "../../assets/images/legacyimage.jpg";
import OfferingsTabs from "../../components/OfferingsTabs/OfferingsTabs";
import "bootstrap/dist/css/bootstrap.min.css";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import { FaArrowUp } from "react-icons/fa";
import apar from "../../assets/images/apar.png";
import empower from "../../assets/images/empower.png";
import fast from "../../assets/images/fast.png";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import jpalmer from "../../assets/caseStudiesImages/jpalmer.jpg";
import los from "../../assets/caseStudiesImages/los.jpg";

const Banking = () => {
  return (
    <div className="banking-page">
      <Helmet>
        <title>IT Services and Solutions for Banking | Idexcel</title>
        <meta
          name="description"
          content="Explore advanced IT services and solutions designed for banking to enhance security, efficiency, and digital transformation. Upgrade your banking technology today!"
        />
      </Helmet>
      {/* //banner section  */}
      <section className="banner-section">
        <Container className="mt-5">
          <Row>
            <Col lg={12}>
              <div className="banner-overlay mt-5">
                <h1 className="banner-title">
                  GenAI-Driven Banking Solutions to Power the Future of Finance
                </h1>
                <Button className="banner-button" size="large" color="banner">
                  <a href="/contact-us" className="text-white">
                    Contact Us
                  </a>
                  <FaArrowUp className="explore-arrow" />
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* section 2 */}

      <section className="image-text-section">
        <Container>
          {/* <motion.div
          className="Productright text-center"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        > */}
          <Row className="custom-flex align-items-center">
            {/* Left Side: Image */}
            <Col lg={6} md={6} sm={12} className="image-box">
              <img src={legacyimage} alt="Tech" className="img-fluid" />
            </Col>

            {/* Right Side: Content */}
            <Col lg={6} md={6} sm={12} className="content-box">
              <h1 className="section-title">
                Is <span className="textgrad">Legacy Technology</span> Holding
                You Back? 
              </h1>
              <Col xs={12} md={9} className="p-0 h-100 w-100">
                <div
                  className=" h-100 flex-column flex-md-row flex-xl-row"
                  style={{
                    display: "flex",
                    gap: "30px",
                  }}
                >
                  {/* First Stat (75%) */}
                  <div className="bor-box">
                    <span
                      style={{
                        fontSize: "46px",
                        color: "#f06319",
                        fontWeight: "700",
                      }}
                    >
                      75%
                    </span>
                    <p style={{ fontSize: "1.25rem" }}>
                      Banks face digital roadblocks due to outdated
                      infrastructure
                    </p>
                  </div>

                  {/* Second Stat (59%) */}
                  <div
                    className="bor-box"
                    style={{
                      gap: "12px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "46px",
                        color: "#f06319",
                        fontWeight: "700",
                      }}
                    >
                      59%
                    </span>
                    <p style={{ fontSize: "1.25rem" }}>
                      Bankers say legacy systems are their biggest challenge
                    </p>
                  </div>
                </div>
              </Col>
            </Col>
          </Row>
          {/* </motion.div> */}
        </Container>
      </section>

      <OfferingsTabs />

      {/* section 2 */}

      <Container className="mb-5 banking-customer" style={{ width: "900px" }}>
        {/* <motion.div
          className="Productright text-center"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.3 }}
        > */}
        <h1 className="text-center  section-title">Customer Success Stories</h1>
        <section className="banking-stories">
          <div className="banking-stories-container">
            {/* First Row - Two Boxes */}
            <div className="banking-stories-row">
              <div className="banking-story-box">
                <img src={jpalmer} alt="Story 1" className="banking-story-image" />
                <h3 className="banking-story-heading">
                  JPalmer Excel Automation: AI-Powered Data Processing with Amazon Bedrock
                </h3>
                <p className="banking-story-text">
                  JPalmer implemented an AI-powered Excel automation system leveraging Amazon Bedrock, enabling intelligent data extraction, mapping, and transformation at scale.
                </p>
                <a
                  href="resources/case-studies/jpalmer-excel-automation-ai-powered-data-processing-with-amazon-bedrock.pdf"
                  className="banking-read-more"
                  target="_blank"
                >
                  Read More <FaArrowUp className="explore-arrow" />
                </a>
              </div>
              <div className="banking-story-box">
                <img src={los} alt="Story 2" className="banking-story-image" />
                <h3 className="banking-story-heading">
                  GenAI-Powered Financial Document Processing: Cync LOS Case Study
                </h3>
                <p className="banking-story-text">
                  NDS Systems integrated AWS Generative AI into Cync LOS, automating financial document processing and accelerating commercial loan origination efficiency.
                </p>
                <a
                  href="resources/case-studies/genai-powered-financial-document-processing-cync-los-case-study.pdf"
                  target="_blank"
                  className="banking-read-more"
                >
                  Read More <FaArrowUp className="explore-arrow" />
                </a>
              </div>
            </div>

            {/* Second Row - Full-Width Box */}
            {/* <div className="banking-stories-row banking-full-width">
              <div className="banking-story-content">
                <h3 className="banking-story-heading">
                  Accelerating Tax Form Processing with Intelligent Document
                  Extraction
                </h3>
                <p className="banking-story-text">
                  A financial services firm reduced processing time and improved
                  accuracy by automating data extraction from US tax forms using
                  a custom solution built on AWS Textract.
                </p>
                <a
                  href="resources/case-studies/Empowering-Structured-Information-Extraction-from-Tax-Forms.pdf"
                  target="_blank"
                  className="banking-read-more"
                >
                  Read More <FaArrowUp className="explore-arrow" />
                </a>
              </div>
              <div className="banking-story-image-container">
                <img
                  src={empower}
                  alt="AI Banking"
                  className="banking-story-image-large"
                />
              </div>
            </div> */}
          </div>
        </section>
        {/* </motion.div> */}
      </Container>

      <GetInTouch
        heading="Redefine Banking With AI"
        headingColMd={8}
        buttonColMd={4}
      />
    </div>
  );
};

export default Banking;
